export const ERROR_PATH = "*";
export const HOME_PATH = "/";
export const ABOUT_PATH = "/about";
export const CONTACT_PATH = "/contactus";
export const INCOMING_PATH = "/incoming";
export const OUTGOING_PATH = "/outgoing";
export const DETAILS_PATH = "/details";
export const PACKAGES_PAGE_PATH = "/packagespage";
export const DAY_TOURS_PAGE_PATH = "/daytourspage";
